"use strict";
'use client';

/**
 * Generated by `./scripts/prebuild/generate-icons.ts`.
 * Run `yarn generate-icons` to regenerate.
 */
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Experimental__IconFollowActive = Experimental__IconFollowActive;
exports.IconFollowActive = IconFollowActive;
var _react = _interopRequireDefault(require("react"));
var _index = require("../../index.js");
/**
 * Our icon component is built on top of Encore's icon set.
 * Read our [iconography documentation](https://encore.spotify.net/foundations/iconography?format=figma-figma) to learn more about the principles our icons were designed upon.
 *
 * [Storybook](https://encore-web.spotify.net/?path=/docs/components-icon--docs) |
 * [Encore site](https://encore.spotify.net/web/components/icon) |
 * [Github](https://ghe.spotify.net/encore/web/tree/master/src/core/components/Icon/icons/IconFollowActive/index.tsx)
 */
function IconFollowActive(props) {
  var _props$autoMirror;
  /* prettier-ignore */
  var iconList = [{
    'size': 16,
    'svgContent': '<path d=\'M6.278 8.26c.243.291.322.659.256.998A5.485 5.485 0 0 1 8.25 13.25 5.475 5.475 0 0 1 7.514 16H16v-.672a4 4 0 0 0-2-3.464l-3.112-1.797a1.2 1.2 0 0 1-.322-1.808l.487-.584c.757-.904 1.28-1.94 1.352-3.177.042-.696-.079-1.418-.2-1.775a3.969 3.969 0 0 0-.823-1.421 4.015 4.015 0 0 0-5.92 0 3.97 3.97 0 0 0-.823 1.421c-.122.357-.242 1.08-.2 1.775.072 1.238.594 2.273 1.352 3.177l.487.584zM2 12.5v-2h1.5v2h2V14h-2v2H2v-2H0v-1.5h2z\'/>'
  }, {
    'size': 24,
    'svgContent': '<path d=\'M8 3H5V0H3v3H0v2h3v3h2V5h3V3zM4 20.63v1.428h19v-1.429a4 4 0 0 0-2-3.464l-4.413-2.548a1.5 1.5 0 0 1-.402-2.26l.613-.735c.95-1.133 1.604-2.432 1.696-3.983.052-.872-.1-1.777-.252-2.225a4.978 4.978 0 0 0-1.032-1.782 5.034 5.034 0 0 0-7.42 0 4.976 4.976 0 0 0-1.032 1.782c-.153.448-.304 1.353-.252 2.225.092 1.551.746 2.85 1.696 3.983l.613.736a1.5 1.5 0 0 1-.402 2.26L6 17.164a4 4 0 0 0-2 3.464z\'/>'
  }];
  var iconSizeValue = props.size ? _index.IconSizeMap[props.size] : props.iconSize;
  var closestSize = (0, _index.findClosestGlyphAvailable)(iconList, iconSizeValue || 24);
  var titleTag = function titleTag(title, titleId) {
    return title ? "<title ".concat(titleId ? "id=\"".concat(titleId, "\"") : "", ">").concat(title, "</title>") : "";
  };
  var descTag = function descTag(desc, descId) {
    return desc ? "<desc ".concat(descId ? "id=\"".concat(descId, "\"") : "", ">").concat(desc, "</desc>") : "";
  };
  var autoMirror = (_props$autoMirror = props.autoMirror) !== null && _props$autoMirror !== void 0 ? _props$autoMirror : false;
  return /*#__PURE__*/_react["default"].createElement(_index.Icon, Object.assign({}, props, {
    autoMirror: autoMirror,
    viewBox: "0 0 ".concat(closestSize.size, " ").concat(closestSize.size),
    dangerouslySetInnerHTML: {
      __html: "".concat(titleTag(props.title, props.titleId)).concat(descTag(props.desc, props.descId)).concat(closestSize.svgContent)
    }
  }));
}

/**
 * @deprecated The name Experimental__IconFollowActive is deprecated and will be archived soon. Use IconFollowActive instead.
 */
function Experimental__IconFollowActive(props) {
  return /*#__PURE__*/_react["default"].createElement(IconFollowActive, props);
}